export const initialise = () => {

  const getOperator = ($stateParams, transportOperatorService) => {
    return transportOperatorService.getOperator($stateParams.operatorId);
  };
  getOperator.$inject = ['$stateParams', 'transportOperatorService'];

  const getOperatorService = ($stateParams, transportOperatorBusRouteService) => {
    return transportOperatorBusRouteService.getTransportOperatorService($stateParams.operatorServiceId);
  };
  getOperatorService.$inject = ['$stateParams', 'transportOperatorBusRouteService'];

  angular.module('app.operators').config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    ($stateProvider, $urlRouterProvider, $locationProvider) => {
      $locationProvider.hashPrefix('');
      $stateProvider.state('operators', {
        url: '/operators',
        parent: 'common',
        templateUrl: 'app/angularJS/features/operators/list/operators-list.html',
        controller: 'OperatorsListController',
        controllerAs: 'vm'
      }).state('operators-create', {
        url: '/operator/create',
        parent: 'common',
        templateUrl: 'app/angularJS/features/operators/create/operator-create.html',
        controller: 'OperatorsCreateController',
        controllerAs: 'vm'
      }).state('operator', {
        url: '/operator/:operatorId',
        parent: 'common',
        template: '<div ui-view></div>',
        controller: 'OperatorPageController',
        controllerAs: 'vm',
        resolve: {
          operator: getOperator
        }
      }).state('operator.summary', {
        url: '/summary',
        templateUrl: 'app/angularJS/features/operators/summary/operator-summary.html',
        controller: 'OperatorSummaryController',
        controllerAs: 'vm',
        data: {
          selectedTab: 0
        }
      }).state('operator.edit', {
        url: '/edit',
        templateUrl: 'app/angularJS/features/operators/edit/operator-edit.html',
        controller: 'OperatorEditController',
        controllerAs: 'vm'
      }).state('operator.services', {
        url: '/services',
        templateUrl: 'app/angularJS/features/operators/services/operator-services-list.html',
        controller: 'OperatorServicesListController',
        controllerAs: 'vm',
        data: {
          selectedTab: 1
        }
      }).state('operator.services-create', {
        url: '/services/create',
        templateUrl: 'app/angularJS/features/operators/services/create/transport-operator-services-create.html',
        controller: 'TransportOperatorServicesCreateController',
        controllerAs: 'vm',
        params: {
          operator: ''
        },
        resolve: {
          operator: getOperator
        }
      }).state('operator.services-edit', {
        url: '/services/:operatorServiceId/edit',
        templateUrl: 'app/angularJS/features/operators/services/edit/transport-operator-service-edit.html',
        controller: 'TransportOperatorServiceEditController',
        controllerAs: 'vm',
        params: {
          operatorServiceId: '',
          operatorId: '',
          previousState: ''
        },
        resolve: {
          operatorService: getOperatorService,
          operator: getOperator
        }
      });
      $urlRouterProvider.otherwise('/');
    }]);
};